<template>
  <div class="submenu">
    <div v-if="claims" class="submenu__menu-outer">
      <div class="buttons-container">
        <el-button type="primary" @click="createNewClaim">
          {{ t('claims.file_new_claim') }}
        </el-button>
        <el-button v-if="shouldShowFnolAgent" type="primary" @click="openAdaptableAgentChat" class="agent-chat-button">
          <div class="agent-chat-button-content">
            <span class="icon-ai agent-chat-button__icon"></span>
            <span>
              {{ t('claims.file_new_claim_using_ai') }}
            </span>
            <beta-chip color="white" />
          </div>
        </el-button>
      </div>
      <div class="submenu__menu-outer_scrolling">
        <div v-for="(type, i) in claimTypes" :index="i">
          <bc-claims-submenu v-if="sortClaimsByDesc[`${type}`].length > 0" :claimsList="sortClaimsByDesc[`${type}`]" :type="type"/>
        </div>
      </div>
    </div>
    <!-- Dialog File a Claim  -->
    <div class="file-claim-dialog-container">
      <el-dialog :visible.sync="dialogClaimVisible"
                custom-class="file-claim-dialog"
                :show-close="true"
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                :before-close="closeClaimDialog"
      >
        <bc-file-claims-view
          v-if="dialogClaimVisible"
          ref="fileClaimView"
          @closeClaimDialog="closeClaimDialog"
          openClaimDialog/>
      </el-dialog>
    </div>
    
    <!-- Dialog Add New Phone Number -->
    <phone-number-dialog />
    
    <div class="submenu__view">
      <router-view :key="$route.fullPath"></router-view>
    </div>
    <adaptable-agent-chat 
      :visible="isAgentChatModalVisible" 
      @close="onAgentChatModalClose" />
  </div>
</template>

<script>
import _ from 'lodash'
import BcClaimsSubmenu from '@/pages/claims/claims-submenu-links.component'
import BcFileClaimsView from '@/pages/claims/file-claim.component'
import PhoneNumberDialog from '@/components/new-phone-number.dialog.vue'
import AdaptableAgentChat from '@/components/adaptable-agent-chat.vue'
import BetaChip from '@shared_src/components/beta-chip.vue'

export default {
  name: 'bc-claims-list',
  components: {
    'bc-claims-submenu': BcClaimsSubmenu,
    'bc-file-claims-view': BcFileClaimsView,
    PhoneNumberDialog,
    'adaptable-agent-chat': AdaptableAgentChat,
    BetaChip,
  },
  props: ['claims'],
  data () {
    return {
      dialogClaimVisible: false,
      claimTypes: ['open', 'closed'],
      isAgentChatModalVisible: false,
    }
  },
  computed: {
    sortClaimsByDesc () {
      let sortClaims = (claims) => _.orderBy(claims, ['date_added'], ['desc'])
      return {
        open: sortClaims(this.claims.open) || [],
        closed: sortClaims(this.claims.closed) || []
      }
    },
    shouldShowFnolAgent () {
      return this.setting('claims.enable_fnol_agent')
    },
  },
  methods: {
    closeClaimDialog () {
      this.dialogClaimVisible = false
    },
    createNewClaim () {
      this.dialogClaimVisible = true
    },
    openAdaptableAgentChat () {
      this.isAgentChatModalVisible = true
    },
    onAgentChatModalClose () {
      this.isAgentChatModalVisible = false
    },
  }
}
</script>

<style lang="scss">
  @import '../../sass/variables';
  .buttons-container {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  
  .file-claim-dialog-container > .el-dialog__wrapper {
    display: flex;
  }

  .file-claim-dialog {
    min-width: 650px !important;
    margin: auto !important;
  
    @media only screen and (max-width: $m-screen) {
      min-width: 95% !important;
    }
    .el-dialog__header {
      padding: 0;
      top: 10px;
      margin-right: 5px;
      .el-dialog__headerbtn .el-dialog__close {
        font-size: 24px;
        color: #626262;
      }
    }
  }
  .agent-chat-button {
    margin-left: 0 !important;
    background: linear-gradient(to right, #793bff, $color-primary ) !important;
    border: none;
    height: 46px;
    &:hover {
      background: linear-gradient(to right, #793bff, $color-primary ) !important;
      opacity: 0.8;
    }
  }
  .agent-chat-button-content {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .agent-chat-button__icon {
    display: inline-block;
    width: 1.25em;
    height: 1.25em;
    background-color: currentColor;
    -webkit-mask-image: url("/static/svg/icons/ai.svg");
    mask-image: url("/static/svg/icons/ai.svg");
    -webkit-mask-size: contain;
    mask-size: contain;
    -webkit-mask-repeat: no-repeat;
    mask-repeat: no-repeat;
    -webkit-mask-position: center;
    mask-position: center;
  }
</style>
